import { Component } from '@angular/core';
import { IntroFourComponent } from './intro-four.component';

@Component({
  selector: 'eid-intro-four-mobile',
  templateUrl: './intro-four.mobile.component.html',
  styleUrls: ['./intro-four.mobile.component.scss']
})
export class IntroFourMobileComponent extends IntroFourComponent {}
